import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ShowcaseStateService {
  expanded = false;
}
